/* =====================================================================
   THE COPY FILE, READ (CW2)

   Every word this page says to a reader lives in src/_data/copy.json and
   nowhere else. base.njk prints that file into the document as one JSON
   block (`survey-copy`, beside the record and the marks), and this is the
   only thing that reads it: one parse, kept, and a lookup by key.

   This file is loaded FIRST, in front of sky.js, because sky.js asks for
   its line the moment it is evaluated. It holds no words of its own.

     RoomCopy.t('terminal.unlink')                -> the line
     RoomCopy.t('voyage.charted', { n: 3, ... })  -> the line with its
                                                     {fields} filled in
     RoomCopy.t('card.mark_names.2')              -> the third of a list
     RoomCopy.has('board.sign')                    -> is there a line at all

   THREE RULES, and they are the whole of the behaviour:
     · a `{field}` the caller names is replaced; one it does not name is
       LEFT ON THE PAGE as it stands, so a misspelt field shows itself;
     · a line that is empty is empty, and the caller decides what an
       empty line means (mostly: it is not printed);
     · a key that is NOT IN THE FILE comes back as `[the.key]`, in
       brackets, so a typo is a visible fault on the sheet and never a
       blank space nobody notices.
   ================================================================== */
(function (root) {
  'use strict';
  var has = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };
  var MAP = null;
  function map() {
    if (MAP) return MAP;
    MAP = {};
    var el = root.document && root.document.getElementById('survey-copy');
    if (el) {
      try { MAP = JSON.parse(el.textContent) || {}; } catch (e) { MAP = {}; }
    }
    return MAP;
  }
  /* a key, or a key and the number of one line of a list: `a.b.0` */
  function look(key) {
    var m = map(), k = String(key);
    if (has(m, k)) return m[k];
    var cut = k.lastIndexOf('.');
    if (cut > 0) {
      var head = k.slice(0, cut), tail = k.slice(cut + 1);
      if (/^\d+$/.test(tail) && has(m, head)) {
        var list = m[head];
        if (list && typeof list.length === 'number' && +tail < list.length) return list[+tail];
      }
    }
    return null;
  }
  root.RoomCopy = {
    /* a LIST key comes back as one comma-joined string (String(array)):
       read one entry as 'key.N' (furn-things.js and terminal.js do) */
    t: function (key, fields) {
      var v = look(key);
      if (v === null || v === undefined) return '[' + key + ']';
      v = String(v);
      if (!fields || v.indexOf('{') < 0) return v;
      return v.replace(/\{([A-Za-z0-9_]+)\}/g, function (whole, name) {
        return has(fields, name) ? String(fields[name]) : whole;
      });
    },
    has: function (key) {
      var v = look(key);
      return v !== null && v !== undefined;
    }
  };
})(window);
